import {RouterModule, Routes} from "@angular/router";
import {ModuleWithProviders} from "@angular/core";
import {HomepageComponent} from "./components/homepage/homepage.component";
import {ErrorComponent} from "./components/error/error.component";
import {SortirComponent} from "./components/sortir/sortir.component";

export const garRoutes: Routes = [
  {
    path: '',
    component: HomepageComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  /*{
    path: 'sortir',
    component: SortirComponent
  }*/
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(garRoutes, { relativeLinkResolution: 'legacy' });
